import { render, staticRenderFns } from "./ChampionshipList.vue?vue&type=template&id=2eac3782"
import script from "./ChampionshipList.vue?vue&type=script&lang=js"
export * from "./ChampionshipList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports